export function getDiscountGrossChartData({
  objects,
  selectedStoreCode,
  selectedMonthName,
  selectedYear,
  monthsToShow = 12,
}) {
  // 1) filter only completed ("C") transactions
  const filtered = (objects || [])
    .filter((o) => o.status === "C")
    .filter((sale) => {
      const d = new Date(sale.tran_date);
      const year = d.getFullYear();
      const month = d.toLocaleString("default", { month: "long" });
      const store = sale.store_code.replace("ANGELSPIZZA_", "");

      const okYear = selectedYear ? year === parseInt(selectedYear, 10) : true;
      const okMonth = selectedMonthName ? month === selectedMonthName : true;
      const okStore = selectedStoreCode ? store === selectedStoreCode : true;

      return okYear && okMonth && okStore;
    });

  // 2) accumulate gross & discount per month over the last `monthsToShow`
  const now = new Date();
  const labels = [];
  const salesData = [];
  const discountData = [];

  for (let i = monthsToShow - 1; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const month = d.getMonth();
    const year = d.getFullYear();

    // pick only transactions in this month/year
    const monthTx = filtered.filter((tx) => {
      const t = new Date(tx.tran_date);
      return t.getMonth() === month && t.getFullYear() === year;
    });

    if (monthTx.length) {
      let grossSum = 0;
      let discountSum = 0;

      monthTx.forEach((tx) => {
        const total = Number(tx.total || 0);
        const discount = Number(tx.discount_amount || 0);
        // as per your logic, gross = total
        grossSum += total;
        discountSum += discount;
      });

      labels.push(
        d.toLocaleString("default", { month: "long", year: "numeric" })
      );
      salesData.push(grossSum);
      discountData.push(discountSum);
    }
  }

  return {
    labels,
    datasets: [
      {
        label: "Gross Sales",
        data: salesData,
        borderColor: "#1b74bb",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
        yAxisID: "y",
      },
      {
        label: "Discount Amount",
        data: discountData,
        borderColor: "rgb(255, 205, 86)",
        backgroundColor: "rgba(255, 205, 86, 0.5)",
        yAxisID: "y1",
      },
    ],
  };
}

/**
 * Build the Chart.js options object for a dual‐axis bar chart:
 *   • y = Gross Sales (left)
 *   • y1 = Discount Amount (right)
 */
export function getDiscountGrossChartOptions() {
  return {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: "Discount Value vs. Gross Sales",
      },
    },
    scales: {
      y: {
        type: "linear",
        display: true,
        position: "left",
        beginAtZero: true,
        title: {
          display: true,
          text: "Gross Sales",
        },
      },
      y1: {
        type: "linear",
        display: true,
        position: "right",
        beginAtZero: true,
        title: {
          display: true,
          text: "Discount Amount",
        },
        grid: {
          drawOnChartArea: false,
        },
      },
      x: {
        title: {
          display: true,
          text: "Month",
        },
      },
    },
  };
}
